import ModalSlideUp, { ModalSlideUpStaticMethods } from "@/components/composite/ModalSlideUp/main"
import { useModalSlideUp } from "@/features/useModal"
import { useSearchAction } from "@/features/useSearchAction"
import LoginPageV2 from "@/pages/LoginPageV2/page"
import Deposit from "@/pages/UserCenterPage/subPages/Deposit"
import DepositMaya from "@/pages/UserCenterPage/subPages/DepositMaya"
import Withdraw from "@/pages/WithdrawAccounts/components/Withdraw"
import { css } from "@emotion/react"
import { useIsomorphicLayoutEffect } from "ahooks"
import kycRequiredMethods from "@/features_signal/kyc/kycRequiredMethods"
import { batch } from "@preact/signals"
import { createLogger } from "@/utils/logger"
import TermsAndConditions from "@/components/pagcor/TermsAndConditions"

const logger = createLogger("search-action-layout")

export default function SearchActionLayout() {
    const { open, close } = useModalSlideUp("search-action")
    const { action, clearAction } = useSearchAction()

    useIsomorphicLayoutEffect(() => {
        batch(async () => {
            await ModalSlideUpStaticMethods.waitModalActing()

            switch (action) {
                case "deposit": {
                    kycRequiredMethods.execute("deposit", async () => {
                        await open(<Deposit />, {
                            closeOnClickMask: true,
                            closeOnEscape: false,
                            onClose: clearAction,
                            position: "bottom",
                            animation: "slide-up",
                        })
                    })
                    break
                }
                case "depositmaya": {
                    kycRequiredMethods.execute("depositmaya", async () => {
                        await open(<DepositMaya />, {
                            closeOnClickMask: true,
                            closeOnEscape: false,
                            onClose: clearAction,
                            position: "bottom",
                            animation: "slide-up",
                        })
                    })
                    break
                }
                case "withdraw": {
                    kycRequiredMethods.execute("withdraw", async () => {
                        await open(<Withdraw />, {
                            closeOnClickMask: true,
                            closeOnEscape: false,
                            onClose: clearAction,
                            position: "bottom",
                            animation: "slide-up",
                        })
                    })

                    break
                }
                case "login": {
                    await open(
                        <div
                            css={css`
                                display: flex;
                                flex-direction: column;
                                border-radius: 16rem 16rem 0 0;
                                overflow: hidden;
                            `}
                        >
                            <LoginPageV2 />
                        </div>,
                        {
                            closeOnClickMask: true,
                            closeOnEscape: false,
                            onClose: clearAction,
                            position: "bottom",
                            animation: "slide-up",
                        },
                    )
                    break
                }
                default: {
                    await close()
                    break
                }
            }
        })
    }, [action, clearAction, open])

    return <ModalSlideUp familyName="search-action" />
}
